
import { usePageTitle } from '../../hooks/usePageTitle';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/base/SEOHead';
import ApplyHeroSection from './components/ApplyHeroSection';
import ApplyFormSection from './components/ApplyFormSection';
import BenefitsSection from './components/BenefitsSection';
import RequirementsSection from './components/RequirementsSection';

export default function Apply() {
  usePageTitle('page_title_apply');

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "达人申请 - 加入Koluno达人营销平台",
    "description": "申请成为Koluno平台达人，获得优质品牌合作机会。我们为创作者提供专业的营销支持和丰厚的合作收益。",
    "url": `${import.meta.env.VITE_SITE_URL || "https://koluno.com"}/apply`,
    "mainEntity": {
      "@type": "Service",
      "name": "达人申请服务",
      "provider": {
        "@type": "Organization",
        "name": "Koluno"
      },
      "description": "为创作者提供品牌合作机会和营销支持服务",
      "serviceType": "Creator Partnership Program"
    }
  };

  return (
    <div className="min-h-screen">
      <SEOHead
        title="达人申请 - 加入Koluno达人营销平台"
        description="申请成为Koluno平台达人，获得优质品牌合作机会。我们为创作者提供专业的营销支持和丰厚的合作收益。"
        keywords="达人申请,创作者招募,KOL申请,网红合作,品牌合作,内容创作者"
        ogTitle="达人申请 - 加入Koluno达人营销平台"
        ogDescription="申请成为Koluno平台达人，获得优质品牌合作机会。我们为创作者提供专业的营销支持和丰厚的合作收益。"
        ogUrl={`${import.meta.env.VITE_SITE_URL || "https://koluno.com"}/apply`}
        twitterTitle="达人申请 - 加入Koluno达人营销平台"
        twitterDescription="申请成为Koluno平台达人，获得优质品牌合作机会。我们为创作者提供专业的营销支持和丰厚的合作收益。"
        structuredData={structuredData}
      />
      
      <Header />
      
      <main className="pt-16">
        <ApplyHeroSection />
        <BenefitsSection />
        <RequirementsSection />
        <ApplyFormSection />
      </main>

      <Footer />
    </div>
  );
}
